import { ScoresObject } from "../../../types";
import { useTranslations } from "../../../contexts/Translation";
import EmScore from "../../../components/Survey/EmScore";
import { ReactNode, useCallback, useId, useState } from "react";
import { HelpIcon, HelpText } from "../Input";
import styles from "./ImprovementSelector.module.css";

type ImpSelProps = {
  score: number;
  label: string;
  name: string;
  isSelected: boolean;
  toggleFn: (n: string, s: boolean) => void;
};

type ComponentProps = {
  scores: ScoresObject | undefined;
  selected: string[];
  handleChange: (s: string[]) => void;
  questions: string[];
  helpText?: ReactNode | string | undefined;
};

const ImprovementSelectorItem = ({ score, label, name, isSelected, toggleFn }: ImpSelProps) => (
  <button className={[styles.item, isSelected && styles.selected].filter(Boolean).join(" ")} onClick={() => toggleFn(name, !isSelected)} type='button'>
    <EmScore labelVariant='compact' size={3} after={label} score={score} />
  </button>
);

const ImprovementSelector = ({ scores, selected, handleChange, questions, helpText }: ComponentProps) => {
  const t = useTranslations("improvementGoals");
  const [helpOpen, setHelpOpen] = useState(false);
  const helpId = useId();
  const closeHelp = useCallback(() => setHelpOpen(false), []);
  if (!scores) {
    return null;
  }

  const onChange = (name: string, isSelected: boolean) => {
    if (isSelected) {
      handleChange([...selected, name]);
    } else {
      handleChange(selected.filter((s) => s !== name));
    }
  };
  type IWProps = { name: string };
  const ItemWrapper = ({ name }: IWProps) => {
    const isSelected = selected.includes(name);
    return (
      <ImprovementSelectorItem
        name={name}
        isSelected={isSelected}
        toggleFn={() => onChange(name, !isSelected)}
        label={t(`${name}Label`)}
        score={scores[name as keyof ScoresObject] || 0}
      />
    );
  };

  return (
    <div className={styles.container}>
      <p className={styles.label}>
        {t("categoriesLabel")} <HelpIcon text={helpText} isOpen={helpOpen} setIsOpen={setHelpOpen} controls={helpId} />
      </p>
      <HelpText text={helpText} isOpen={helpOpen} id={helpId} onClose={closeHelp} />
      <div className={styles.grid}>
        {questions.map((question) => (
          <ItemWrapper key={question} name={question} />
        ))}
      </div>
    </div>
  );
};

export default ImprovementSelector;
